import { CODIGOS_CONSULTA } from "./CodigosConsulta";

export interface FiltroConsultaMasiva {
    dniEmpleador: string,
    fechaInicial: string,
    fechaFinal: string,
    servicio: number,
    consecutivoSolicitud?: string,
    estados?: Array<string>,
    dniUsuarioOperacion: string
}

export interface FiltroConsultaReciboResumen extends FiltroConsultaMasiva{
    paginaActual?: number,
    tamanoPagina?: number,
    codigoConsulta: CODIGOS_CONSULTA
}

export interface FiltroConsultaReciboDetalle extends FiltroConsultaMasiva{
    paginaActual?: number,
    tamanoPagina?: number,
    codigoConsulta: CODIGOS_CONSULTA
}

export const listarServicios = (serviciosReciboSat: any) => {
    if(serviciosReciboSat){
        return [].concat(
            serviciosReciboSat.map(value => ({
                value: value.codigo,
                label: value.nombre ? value.nombre : `Servicio ${value.codigo}`
            })
            ));
    }
};

export const listaEstadosReciboSAT = (estadoReciboSAT : any) => {
    if (estadoReciboSAT) {
        return estadoReciboSAT.map(estado => ({
            value: estado.estado,
            label: estado.nombre
        }));
    }
    return [{ value: '', label: 'Cargando...' }];
};



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general_recibo/modelo/NovedadesRecibidas.ts